import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import { Exposure } from '../../../types/policy';
import AddedExposurePerils from './AddedExposurePerils';
import ExistingExposurePerils from './ExistingExposurePerils';

interface Props {
	authData: AuthData;
	renewalData: RenewalData;
}

/**
 * The component that will render either an added or existing exposure's peril list.
 */
const Perils = (props: Props) => {
	const { selectedExposure } = props.renewalData;

	if (!(selectedExposure as Exposure).displayId) {
		return <AddedExposurePerils />;
	} else {
		return <ExistingExposurePerils />;
	}
};

export default withRenewalContext<Props>(Perils);
